import NewOrder from './NewOrder.jsx';

export {
  NewOrder
}


// WEBPACK FOOTER //
// ./components/my-business/sub-view/the-news/new-order/index.js